<template>
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :rowKey="rowKey"
        :loading="{spinning: loading}"
        :pagination="pagination"
        :rowSelection="rowSelection"
        :locale="localeRes"
        :scroll="scroll ? scroll : {}"
        @change="change"
    >
        <!--账户-->
        <span slot="user_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('user_username')" href="javascript:void(0);" @click="actionFun('username', row)">用户名</a>
            <a v-if="check_limit('user_mobile')" href="javascript:void(0);" @click="actionFun('mobile', row)">手机</a>
            <a v-if="check_limit('user_passwd')" href="javascript:void(0);" @click="actionFun('passwd', row)">密码</a>
            <a v-if="check_limit('user_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
            <a v-else-if="check_limit('user_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">恢复</a>
        </span>

        <!--简历拜访记录-->
        <span slot="revisit_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('revisit_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
        </span>

        <!--标签-->
        <span slot="flag_name" slot-scope="text, row, index" class="action-oper" style="vertical-align: middle">
            <a href="javascript:void(0);" @click="actionFun('search', row)">{{ text }}</a>
        </span>
        <span slot="flag_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('flag_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
        </span>

        <!--简历-->
        <span slot="resume_name" slot-scope="text, row, index" class="action-oper" style="vertical-align: middle">
            <a href="javascript:void(0);" @click="actionFun('edit', row)">{{ text }}</a>
        </span>
        <span slot="resume_remark" slot-scope="text, row, index" class="action-oper" style="vertical-align: middle">
            <div style="line-height: 30px;">
                {{ text }}
                <a-tag v-for="(item, key) in row.flag" :key="key" color="blue">{{ item.fname }}</a-tag>
            </div>
        </span>
        <span slot="resume_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('revisit_save')" href="javascript:void(0);" @click="actionFun('visit', row)">拜访</a>
            <a v-if="check_limit('psi_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
            <a v-else-if="check_limit('psi_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">恢复</a>
        </span>

        <!--货物-->
        <span slot="psilog_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('psilog_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
        </span>

        <!--货物-->
        <span slot="psi_image" slot-scope="text, row, index" class="action-oper" style="vertical-align: middle">
            <div style="width:60px;height: 60px;overflow: hidden;display: flex;justify-content:center;align-items:center;">
                <a :href="row.image_str" target="_blank" v-if="row.image"><img :src="row.image_str" width="60" /></a>
            </div>
        </span>
        <span slot="psi_name" slot-scope="text, row, index" class="action-oper" style="vertical-align: middle">
            <a href="javascript:void(0);" @click="actionFun('edit', row)">{{ text }}</a>
        </span>
        <span slot="psi_action" slot-scope="text, row, index" class="action-oper" style="line-height: 30px;">
            <a v-if="check_limit('psilog_save')" href="javascript:void(0);" @click="actionFun('log_in', row)">入库</a>
            <a v-if="check_limit('psilog_save')" href="javascript:void(0);" @click="actionFun('log_out', row)">出库</a>
            <a v-if="check_limit('psilog_save')" href="javascript:void(0);" @click="actionFun('log_pan_in', row)">盘盈</a>
            <a v-if="check_limit('psilog_save')" href="javascript:void(0);" @click="actionFun('log_pan_out', row)">盘亏</a>
            <a v-if="check_limit('psilog_list')" href="javascript:void(0);" @click="actionFun('log_list', row)">明细</a>
            <a v-if="check_limit('psi_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
            <a v-else-if="check_limit('psi_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">恢复</a>
        </span>


        <!--工资-->
        <span slot="month_str" slot-scope="text, row, index" class="action-oper">
            <a href="javascript:void(0);" @click="locationTo('sabill', row)">{{ text }}</a>
        </span>
        <span slot="sabill_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('sabill_edit') && false" href="javascript:void(0);" @click="actionFun('edit', row)">编辑</a>
            <a v-if="check_limit('sabill_import')" href="javascript:void(0);" @click="actionFun('import', row)">上传工资</a>
            <a v-if="check_limit('sabill_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
            <a v-else-if="check_limit('sabill_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">恢复</a>
        </span>
        <!--工资列表-->
        <span slot="salary_action" slot-scope="text, row, index" class="action-oper">
            <a href="javascript:void(0);" @click="actionFun('view', row)">查看</a>
            <a v-if="check_limit('salary_show_close') && row.show == 1" href="javascript:void(0);" @click="actionFun('unshow', row)">隐藏</a>
            <a v-else-if="check_limit('salary_show_open') && row.show != 1" href="javascript:void(0);" @click="actionFun('show', row)">可查</a>
            <a v-if="check_limit('salary_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
            <a v-else-if="check_limit('salary_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">恢复</a>
        </span>

        <!--员工管理-->
        <span slot="empname" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('employee_edit') && row.empid > 0" href="javascript:void(0);" @click="locationTo('empEdit', row)">{{text}}</a>
            <span v-else>{{text}}</span>
            <a-tag v-if="row.empContract == 1" title="合同已过期">过期</a-tag>
            <a-tag v-else-if="row.empContract == 2" color="orange" title="合同即将到期">将期</a-tag>
            <a-tag v-if="row.empRetirement == 1" title="已到退休年龄">退休</a-tag>
            <a-tag v-else-if="row.empRetirement == 2" color="red" title="即将到退休年龄">将休</a-tag>
        </span>
        <span slot="employee_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('employee_edit')" href="javascript:void(0);" @click="locationTo('empEdit', row)">编辑</a>
            <a v-if="check_limit('employee_departure') && row.departure == 0" href="javascript:void(0);" @click="actionFun('departure', row)">离职</a>
            <a v-else-if="check_limit('employee_join') && row.departure == 1" href="javascript:void(0);" @click="actionFun('join', row)">入职</a>
            <a v-if="check_limit('employee_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
            <a v-else-if="check_limit('employee_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">恢复</a>
        </span>
        <!--员工合同-->
        <span slot="empcontract_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('employee_contract_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
        </span>

        <!--职位管理-->
        <span slot="jobname" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('job_edit')" href="javascript:void(0);" @click="locationTo('jobEdit', row)">{{text}}</a>
        </span>
        <span v-if="showOperate == 'employee'" slot="job_action" slot-scope="text, row, index" class="action-oper">
            <a href="javascript:void(0);" @click="actionFun('employee', row)">新增员工</a>
            <a href="javascript:void(0);" @click="actionFun('empImport', row)">导入员工</a>
        </span>
        <span v-else slot="job_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('job_edit')" href="javascript:void(0);" @click="locationTo('jobEdit', row)">编辑</a>
            <a v-if="check_limit('job_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
            <a v-else-if="check_limit('job_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">恢复</a>
        </span>

        <!--企业管理-->
        <span slot="ename" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('enterprise_edit')" href="javascript:void(0);" @click="locationTo('enterEdit', row)">{{text}}</a>
            <a-tag v-if="row.enterContract == 1" title="合同已过期">过期</a-tag>
            <a-tag v-else-if="row.enterContract == 2" color="orange" title="合同即将到期">将期</a-tag>
        </span>
        <span v-if="showOperate == 'job'" slot="enterprise_action" slot-scope="text, row, index" class="action-oper">
            <a href="javascript:void(0);" @click="actionFun('job', row)">新增职位</a>
        </span>
        <span v-else-if="showOperate == 'salary'" slot="enterprise_action" slot-scope="text, row, index" class="action-oper">
            <a href="javascript:void(0);" @click="actionFun('salary', row)">新增工资账单</a>
        </span>
        <span v-else slot="enterprise_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('enterprise_edit')" href="javascript:void(0);" @click="locationTo('enterEdit', row)">编辑</a>
            <a v-if="check_limit('enterprise_service_close') && row.service == 1" href="javascript:void(0);" @click="actionFun('sclose', row)">终止服务</a>
            <a v-else-if="check_limit('enterprise_service_open') && row.service == 2" href="javascript:void(0);" @click="actionFun('sopen', row)">恢复服务</a>
            <a v-if="check_limit('enterprise_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
            <a v-else-if="check_limit('enterprise_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">恢复</a>
        </span>
        <!--企业合同-->
        <span slot="entercontract_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('enterprise_contract_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">删除</a>
        </span>

        <!--用户列表-->
        <span slot="account_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('system_user_info')" href="javascript:void(0);" @click="actionFun('edit', row)">编辑</a>
            <a href="javascript:void(0);" @click="actionFun('close', row)" v-if="check_limit('system_close_user') && row.status == 1">关闭</a>
            <a v-else-if="check_limit('system_open_user')" href="javascript:void(0);" @click="actionFun('open', row)">开启</a>
        </span>

        <!--部门列表-->
        <span slot="role_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('system_role_info')" href="javascript:void(0);" @click="actionFun('edit', row)">编辑</a>
            <a v-if="check_limit('system_delete_role')" href="javascript:void(0);" @click="actionFun('delete', row)">删除</a>
        </span>

        <!--主账户管理-->
        <span slot="act_action" slot-scope="text, row, index" class="action-oper">
            <a v-if="check_limit('account_edit')" href="javascript:void(0);" @click="actionFun('edit', row)">续费</a>
            <a v-if="check_limit('account_open') && row.status == 9" href="javascript:void(0);" @click="actionFun('open', row)">开启</a>
            <a v-if="check_limit('account_close') && row.status == 1" href="javascript:void(0);" @click="actionFun('close', row)">关闭</a>
        </span>


    </a-table>
</template>

<script>
    export default {
        props: {
            // 字段
            columns: {
                type: Array,
                default: [],
            },
            // 数据
            dataSource: {
                type: [Object, Array],
                default: null,
            },
            // loading加载
            loading: {
                type: Boolean,
                default: false,
            },
            // 表格行 key 的取值
            rowKey: {
                type: String,
                default: '',
            },
            // 页码{ pageSize: pageSize, total: total, current: current, }
            pagination: {
                type: [Boolean, Object],
                default: false,
            },
            // 列表项是否可选择
            rowSelection: {
                type: [Object],
                default: null,
            },
            // 默认文案设置
            locale: {
                type: Object,
                default: null,
            },
            // 滚动条设置
            scroll: {
                type: Object,
                default: null,
            },
            operate: {
                type: String,
                default: '1',
            },
        },
        watch: {
            operate(val) {
                this.showOperate = val;
            }
        },
        data() {
            return {
                // indicator: <i class="anticon anticon-loading anticon-spin ant-spin-dot" style="font-size: 24px;"></i>,
                localeRes: {
                    emptyText: '暂无数据'
                },
                showOperate: this.operate, // 显示页面默认操作按钮
            }
        },
        methods: {
            // 分页回调
            change(e) {
                this.$emit('page', e);
            },
            actionFun(op, row) {
                row.op = op;
                this.$emit('actionFun', row);
            },
            locationTo(op, row) {
                let url = '';
                switch (op) {
                    case 'enterEdit':
                        url = '/enterprise/edit?eid=' + row.eid;
                        break;
                    case 'jobEdit':
                        url = '/job/edit?jid=' + row.jid;
                        break;
                    case 'empEdit':
                        url = '/employee/edit?empid=' + row.empid;
                        break;
                    case 'sabill':
                        url = '/salary/list?sbid=' + row.sbid;
                        break;
                    default:
                        break;
                }

                if (url != '') {
                    this.$router.push(url);
                }
            }
        }
    }
</script>

<style lang="less">
    .action-oper{
        a{
            margin-right: 10px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
</style>
